// Centralized reduced-motion-safe transition presets — UX_MOTION.md §0 hard rule: every
// animation must be neutralized under prefers-reduced-motion. Framer-motion drives these via
// rAF/WAAPI (not CSS transitions), so the global CSS override in tokens.css has no effect on
// them — every motion.* usage must consult useReducedMotion() and use one of these instead of a
// hardcoded transition. (Found missing on several components by the testing agent — centralized
// here so it can't be missed again.)
export function fadeUp(reducedMotion, delay = 0, distance = 8) {
  if (reducedMotion) return { initial: { opacity: 1, y: 0 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0 } };
  return {
    initial: { opacity: 0, y: distance },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.32, delay, ease: [0.22, 1, 0.36, 1] },
  };
}

export function fadeIn(reducedMotion, delay = 0) {
  if (reducedMotion) return { initial: { opacity: 1 }, animate: { opacity: 1 }, transition: { duration: 0 } };
  return { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.22, delay } };
}
